import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LoginIcon(props: IconProps) {
    return <Icon {...props} iconKey={"login"}/>
}
